import React from 'react'
import ContactForm from '../Common/ContactForm'

const HomeContact = ({cls}) => {
  return (
    <>
      <section className={`hm-contact-wrap ${cls}`}>
        <div className='container'>
          <h4 className='lg-title font-3em fw-500 wow reveal fadeInUp ps-3 ps-md-0'>Contact Us</h4>
          <div className='mt-lg-5 mt-3 row'>
            <div className='col-lg-6 pt-2 wow reveal fadeInLeft'>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3579.1675158899957!2d-80.124234!3d26.223746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d902f67c8adb35%3A0xb227904b34e747a!2sMercedeshowroom!5e0!3m2!1sen!2sin!4v1746817821101!5m2!1sen!2sin" width="100%" height="460" style={{ border: 'none' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
              <div className='gt-info mt-md-4 mt-0'>
                <div className='lg-title font-1-3em mb-2'>MERCEDESHOWROOM</div>
                <div className='md-title font-1em fw-500 mb-3'>51 & 61 SW 5th Court Pompano Beach, FL 33060</div>
                <div className='md-title mt-2'><a href='tel:9549463000' className='text-white'>(954) 946-3000</a></div>
              </div>
            </div>
            <div className='col-lg-6 wow reveal fadeInRight mt-md-5 mt-4 mt-lg-0'>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default HomeContact